import React, { Component, useState } from "react";
import { styleClasses } from "./ticketsStyleClasses";
import TicketLayout, { ContentLayout } from "./layout";
import EventHeader from "../EventDetails/eventHeader";
import AddIcon from "@material-ui/icons/Add";
import { Close, Create, Delete } from "@material-ui/icons";
import {
  Box,
  Button,
  withStyles,
  Modal,
  Input,
  InputAdornment,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { eventApis, Text, Tickets, Events } from "../../../../Constants";
import DateAndTime from "./dateAndTime";
import moment from "moment";
import { axiosE } from "../../../../Service/service";
import Loader from "../../../../Helper/loader/loader";
import {
  addAddOn as addAddonAction,
  deleteAddOn as deleteAddonAction,
  setEventType,
  updateAddOn as updateAddonAction,
} from "../../../../Actions/eventActions";
import { default as momentTz } from "moment-timezone";
import { checkIfEventExists } from "../../../../Helper/Validations";
import { cloneDeep } from "lodash";
import CreateEventErrorMessage from "../createEventErrorMessage";
import { Download } from "@mui/icons-material";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";

const styles = {
  inputLabel: styleClasses.inputLabel,
  addButton: styleClasses.addButton,
  createButtonAddText: styleClasses.createButtonAddText,
  createButtonPlusIcon: styleClasses.createButtonPlusIcon,
  // Empty state
  emptyState: styleClasses.emptyState,
  emptyHeader: {
    marginTop: "10px",
  },
  // Save And Continue Button Styles
  saveAndContinueButton: styleClasses.saveAndContinueButton,
  saveAndContinueButtonWrapper: styleClasses.saveAndContinueButtonWrapper,

  // addupdatemodal
  addUpdateModal: styleClasses.addUpdateModal,
  addUpdateModalMainWrapper: styleClasses.addUpdateModalMainWrapper,
  addUpdateModalHeader: styleClasses.addUpdateModalHeader,
  addUpdateModalHeaderText: styleClasses.addUpdateModalHeaderText,
  addUpdateModalButtonWrapper: {
    ...styleClasses.addUpdateModalButtonWrapper,
    marginTop: "20px",
  },
  addUpdateModalButtonWrapperCondition: {
    display: "flex",
    gap: "10px",
    width: "100%",
    padding: "30px",
    alignItems: "center",
    justifyContent: "center",
    borderTop: "1px solid #ced4da",
    marginTop: "auto",
    textAlign: "center",
  },
  addUpdateModalButtonCancel: styleClasses.addUpdateModalButtonCancel,
  addUpdateModalButtonSave: styleClasses.addUpdateModalButtonSave,
  addUpdateModalCloseIcon: styleClasses.addUpdateModalCloseIcon,
  createEventFAQGridWrapper: {
    margin: "2px 0px 0px 0px",
    display: "grid",
  },
  createResetText: {
    marginBottom: "15px",
    color: "red",
    fontSize: "9.5px",
    fontWeight: "400",
    cursor: "pointer",
  },
  createEventFAQLongInputField: {
    border: "1px solid #ced4da",
    borderRadius: "5px",
    fontSize: "16px",
    padding: "10px",
    margin: "15px 0px 20px 0px",
    width: "auto",
  },
  createEventFAQInputLabel: {
    fontSize: "16px",
    fontWeight: "550",
  },
  createEventFAQInputText: {
    fontSize: "16px",
  },
  createEventFAQSubmittedFAQ: {
    borderLeft: "10px solid #00BAFF",
  },
  createEventFAQButtonWrapperModal: {
    textAlign: "center",
    borderTop: "1px solid #ced4da",
    paddingTop: "20px",
    marginTop: "auto",
    marginBottom: "40px",
  },
  createEventFAQCancelFAQButton: {
    fontSize: "1.5rem",
    marginRight: "20px",
    border: "1px solid #968e8e",
    width: "120px",
    height: "50px",
  },
  createEventFAQSaveFAQButton: {
    backgroundColor: "rgb(182, 14, 181)",
    fontSize: "1.5rem !important",
    color: "white",
    borderRadius: "9px",
    width: "120px",
    height: "50px",
  },
  createEventFAQEditAndDeleteFAQButtonWrapper: {
    margin: "0px 0px 0px 5px",
    justifyContent: "flex-end",
    display: "flex",
  },
  createEventFAQEditAndDeleteFAQButton: {
    color: "gray",
    cursor: "pointer",
  },
  addOnNameInputHelperText: {
    textAlign: "end",
    margin: 0,
    fontSize: "12px",
    color: "#808080 !important",
  },

  addOnNameInputHelperTextwithErr: {
    textAlign: "start",
    margin: 0,
    fontSize: "9px",
  },
  mainContentWrapper: styleClasses.mainContentWrapper,

  addOnWrapper: {
    display: "flex",
    border: "1px solid #ced4da",
    borderRadius: "10px",
  },
  addOnWrappersub: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 480px)": {
      display: "block",
      marginTop: "10px",
      textAlign: "start",
      alignItems: "start",
      padding: "15px",
    },
  },
  addOnCardColumnOne: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    gap: "15px",
  },
  addOnCardColumnTwo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
    "@media (max-width: 480px)": {
      flexDirection: "row-reverse",
      marginTop: "10px",
      textAlign: "start",
      alignItems: "start",
    },
  },
  addOnCardSpecialFlag: {
    padding: "3px 30px",
    color: "white",
    borderRadius: "10px",
    marginRight: "10px",
  },
  addOnCardButtonWrapper: {
    display: "flex",
    gap: "20px",
    opacity: 0.8,
  },
  deleteModalMainWrapper: styleClasses.deleteModalMainWrapper,
  deleteModalImgWrapper: styleClasses.deleteModalImgWrapper,
  deleteModalImg: styleClasses.deleteModalImg,
  deleteModalSaveAndCancelButton: styleClasses.deleteModalSaveAndCancelButton,
};

let currentDefault = {
  addOnName: "",
  addOnDescription: "",
  addOnQuantity: "",
  addOnPrice: "",
  color: "#b60eb5",
  ticketsTypes: [],
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  isDeleted: false,
};

class AddOns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addons: [],
      addModal: false,
      editAddonModal: { show: false, index: "" },
      deleteAddOnsModal: { show: false, index: "" },
      currentAddOns: cloneDeep(currentDefault),
      addOnQuantityErrorMessage: "",
      addOnQuantityError: false,
      error: { show: false, message: "" },
      errorMessage: "",
      allAddOns: [],
      deleteError: { show: false, messageTitle: "", messageBody: "" },
      showDateAndTime: false,
    };
  }

  getCompositeDateAndTime = (date, time, start) => {
    if (!date && !time) return null;
    const { TimeZone, StartDateTime, EndDateTime } = this.props.eventsAbout;
    const currentDateTime = start
      ? this.timeUTCtoLocal(StartDateTime)
      : this.timeUTCtoLocal(EndDateTime);
    let formattedTime = currentDateTime;
    let formattedDate = currentDateTime;
    if (time) {
      formattedTime = time.format("hh:mm:ss a");
    } else {
      formattedTime = currentDateTime.format("hh:mm:ss a");
    }

    if (date) {
      formattedDate = date.format("DD-MM-YYYY");
    } else {
      formattedDate = currentDateTime.format("DD-MM-YYYY");
    }
    const dateAndTimeString = formattedDate + " " + formattedTime;
    var dateTimeInUtc = momentTz
      .tz(dateAndTimeString, "DD-MM-YYYY hh:mm:ss a", TimeZone)
      .utc()
      .format();

    return dateTimeInUtc;
  };

  handleAddModal = () => {
    this.setState({ addModal: !this.state.addModal, showDateAndTime: false });
  };

  addAddToRemote = async () => {
    const { addAddonAction, eventId } = this.props;
    const currentAddOn = cloneDeep(this.state.currentAddOns);

    const updatedTicketTypes = currentAddOn.all
      ? []
      : currentAddOn.ticketsTypes
        .filter((ticket) => ticket.checked)
        .map((ticket) => ticket.ticketId);

    const res = await addAddonAction({
      Name: currentAddOn.addOnName,
      Description: currentAddOn.addOnDescription,
      QuantityAvailable: currentAddOn.addOnQuantity,
      Price: currentAddOn.addOnPrice,
      Color: currentAddOn.color,
      TicketIdsJson: JSON.stringify(updatedTicketTypes),
      AppliesToAllTickets: currentAddOn.all,
      StartDateTime: this.getCompositeDateAndTime(
        currentAddOn.startDate,
        currentAddOn.startTime,
        true
      ),
      EndDateTime: this.getCompositeDateAndTime(
        currentAddOn.endDate,
        currentAddOn.endTime,
        false
      ),
      EventId: eventId,
    });

    return res;
  };

  addAddon = async () => {
    const { currentAddOns } = this.state;
    const { eventId } = this.props;
    this.setState({ loading: true });
    this.setEventTypeRemote(currentAddOns.addOnPrice > 0 ? 1 : 0);
    const { AddOnId } = await this.addAddToRemote();
    this.getaddonsByEventID(eventId);
    this.setState({
      currentAddOns: cloneDeep(currentDefault),
      addModal: false,
      loading: false,
      showDateAndTime: false,
    });
  };

  setEventTypeRemote = (type) => {
    const { setEventType, eventType } = this.props;
    if (!eventType || eventType === "") {
      if (type === 1) {
        setEventType({ type: "Paid" });
      }
      if (type === 0) {
        setEventType({ type: "Free" });
      }
    } else if (eventType === "Free" && type === 1) {
      setEventType({ type: "Paid" });
    }
  };

  setEventTypeOnDelete = (index, addons) => {
    const noOfPaidAddons = addons.filter(
      (addon) => addon.addOnPrice > 0
    ).length;
    const noOfFreeAddons = addons.filter(
      (addon) => addon.addOnPrice === 0
    ).length;

    if (addons.length === 1) {
      this.props.setEventType({ type: "" });
    } else if (
      noOfPaidAddons === 1 &&
      addons[index].addOnPrice > 0 &&
      noOfFreeAddons > 0
    ) {
      this.props.setEventType({ type: "Free" });
    }
  };

  updateAddonRemote = async () => {
    const { currentAddOns } = this.state;
    const { updateAddonAction, eventId } = this.props;

    const currentAddOn = cloneDeep(currentAddOns);

    const updatedTicketTypes = currentAddOn.all
      ? []
      : currentAddOn.ticketsTypes
        .filter((ticket) => ticket.checked)
        .map((ticket) => ticket.ticketId);

    const res = await updateAddonAction({
      AddOnId: currentAddOn.AddOnId,
      Name: currentAddOn.addOnName,
      Description: currentAddOn.addOnDescription,
      QuantityAvailable: currentAddOn.addOnQuantity,
      Price: currentAddOn.addOnPrice,
      Color: currentAddOn.color,
      TicketIdsJson: JSON.stringify(updatedTicketTypes),
      AppliesToAllTickets: currentAddOn.all,
      StartDateTime: this.getCompositeDateAndTime(
        currentAddOn.startDate,
        currentAddOn.startTime,
        true
      ),
      EndDateTime: this.getCompositeDateAndTime(
        currentAddOn.endDate,
        currentAddOn.endTime,
        false
      ),
      EventId: eventId,
    });

    if (res?.data?.results?.ResponseCode) {
      return JSON.parse(res?.data?.results?.Data);
    } else {
      console.error({ err: "Error in updateTicketRemote api!" });
    }
  };

  saveEditedAddon = async () => {
    const { editAddonModal, currentAddOns } = this.state;
    const { eventId } = this.props;
    this.setState({
      loading: true,
    });
    this.setEventTypeRemote(currentAddOns.addOnPrice > 0 ? 1 : 0);
    await this.updateAddonRemote();
    this.getaddonsByEventID(eventId);
    this.setState({
      currentAddOns: cloneDeep(currentDefault),
      editAddonModal: { show: false, index: "" },
      loading: false,
      showDateAndTime: false,
    });
  };

  timeUTCtoLocal = (date) => {
    if (!date) return "";
    if (this.props.eventsAbout) {
      const { TimeZone } = this.props.eventsAbout;
      var local = momentTz
        .tz(moment.utc(date), "MM/DD/YYYY hh:mm:ss a", TimeZone)
        .format("MM/DD/YYYY hh:mm:ss a");
      return moment(local, "MM/DD/YYYY hh:mm:ss a");
    }
  };

  setEditState = (show, index = "") => {
    this.setState({
      editAddonModal: { show: show, index: index },
      currentAddOns: cloneDeep(currentDefault),
      showDateAndTime: false,
    });
  };

  checkEventIsExpired = () => {
    const About = this.props.eventsAbout;
    const EndDateTime = About ? About.EndDateTime : null;

    if (this.timeUTCtoLocal(EndDateTime).isBefore(moment())) {
      this.setState({
        loading: false,
        error: {
          show: true,
          message: "Event Expired! Change event end date or create a new Date",
          disableButton: true,
        },
      });
    }
  };

  getTicketsCat = (isReturn = false) => {
    const { eventId } = this.props;
    axiosE
      .get(`${eventApis.getTicketByEventId}/${eventId}`)
      .then(({ data }) => {
        const Tickets = data.results.ListTicket;
        if (Tickets && Tickets.length > 0) {
          currentDefault = {
            ...currentDefault,
            ticketsTypes: data.results.ListTicket.map((ticket) => {
              return {
                title: ticket.Title,
                type: ticket.TicketType,
                checked: false,
                ticketId: ticket.TicketId,
              };
            }),
          };
          this.setState({
            currentAddOns: cloneDeep(currentDefault),
          });
          this.getaddonsByEventID(eventId);
        } else {
          this.setState({
            error: {
              show: true,
              message:
                "You do not have any tickets created, Please create tickets under Create Tickets tab.",
            },
            disableButton: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    checkIfEventExists(this.props.history, this.props.eventId);
    this.setState({
      loading: true,
    });

    this.checkEventIsExpired();
    this.getTicketsCat();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.addModal !== prevState.addModal ||
      this.state.editAddonModal.show !== prevState.editAddonModal.show
    ) {
      this.setState((prevState) => ({
        ...prevState,
        error: { show: false, message: "" },
        errorMessage: "",
        addOnQuantityErrorMessage: "",
        addOnQuantityError: false,
      }));
    }
  }

  validateAddOnName = (e, name) => {
    const newValue = e.target.value;

    if (newValue.match("^[A-Za-z0-9 _-]*$")) {
      //
      this.handleInputChange(e, name);
      this.setState({
        error: false,
        errorMessage: "",
      });
    } else {
      this.setState({
        error: true,
        errorMessage: Tickets.addons.addAddons.codeError,
      });
    }
  };

  handleInputChange = (e, field) => {
    const { currentAddOns } = this.state;
    const value = e.target.value;
    let newValue = value;
    if (!isNaN(value.trim())) {
      newValue = value.trim() >= 0 ? value.trim() : 0;
    }
    currentAddOns[field] = newValue;

    this.setState({ currentAddOns });
  };

  validateInput = (e, name, sold) => {
    const newValue = e.target.value;
    if (name === "addOnQuantity") {
      if (newValue > 0) {
        if (this.state.currentAddOns.hasOwnProperty("AddOnId")) {
          if (newValue < sold) {
            this.setState({
              [`${name}Error`]: true,
              [`${name}ErrorMessage`]:
                "Quantity cannot be less than addons sold.",
            });
          } else {
            this.setState({
              [`${name}Error`]: false,
              [`${name}ErrorMessage`]: "",
            });
          }
        } else {
          this.setState({ [`${name}Error`]: false, [`${name}ErrorMessage`]: "" });
        }
      } else {
        this.setState({
          [`${name}Error`]: true,
          [`${name}ErrorMessage`]: "Quantity must be greater than 0",
        });
      }
    } else {
      if (!newValue || newValue > 0) {
        this.setState({
          [`${name}Error`]: false,
          [`${name}ErrorMessage`]: "",
        });
      } else {
        this.setState({
          [`${name}Error`]: true,
          [`${name}ErrorMessage`]: Tickets.addons.addAddons.invalidNumber,
        });
      }
    }

    this.handleInputChange(e, name);
  };

  ChangeStartDate = (date) => {
    const completeDate = `${date.day}-${date.month}-${date.year}`;
    const newDate = moment(completeDate, "DD-MM-YYYY");

    const { eventsAbout } = this.props;
    const { EndDateTime } = eventsAbout;

    const endDate = moment(
      this.timeUTCtoLocal(EndDateTime).format("DD-MM-YYYY"),
      "DD-MM-YYYY"
    );
    if (newDate.isSame(endDate)) {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          startDate: newDate,
        },
      });
    } else {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          startDate: newDate,
        },
      });
    }
  };

  ChangeEndDate = (date) => {
    const completeDate = `${date.day}-${date.month}-${date.year}`;
    const newDate = moment(completeDate, "DD-MM-YYYY");
    const { eventsAbout } = this.props;
    const { EndDateTime } = eventsAbout;

    const endDate = moment(
      this.timeUTCtoLocal(EndDateTime).format("DD-MM-YYYY"),
      "DD-MM-YYYY"
    );

    if (newDate.isSame(endDate)) {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          endDate: newDate,
          endTime: this.timeUTCtoLocal(EndDateTime),
        },
      });
    } else {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          endDate: moment(completeDate, "DD-MM-YYYY"),
        },
      });
    }
  };
  ChangeStartTime = (date) => {
    if (date === null || date === "invalid date") {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          startTime: moment(),
        },
      });
    } else {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          startTime: moment(date),
        },
      });
    }
  };

  ChangeEndTime = (date) => {
    if (date === null || date === "invalid date") {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          endTime: moment(),
        },
      });
    } else {
      this.setState({
        currentAddOns: {
          ...this.state.currentAddOns,
          endTime: moment(date),
        },
      });
    }
  };

  handleCheckboxChange = (event, index) => {
    const { currentAddOns } = this.state;
    const newCategories = [...currentAddOns.ticketsTypes];
    newCategories[index].checked = event.target.checked;

    this.setState({
      currentAddOns: {
        ...currentAddOns,
        ticketsTypes: [...newCategories],
        all: newCategories.every((category) => category.checked),
      },
    });
  };
  handleCheckboxAllChange = (event) => {
    const { currentAddOns } = this.state;
    this.setState({
      currentAddOns: {
        ...currentAddOns,
        all: event.target.checked,
        ticketsTypes: currentAddOns.ticketsTypes.map((ticket) => {
          return { ...ticket, checked: event.target.checked };
        }),
      },
    });
  };

  combineDateAndTime = (date, time) => {
    const dateMoment = moment(date);
    const timeMoment = moment(time);
    const formattedDate = dateMoment.format("DD-MM-YY");
    const formattedTime = timeMoment.format("hh:mm:ss a");

    const dateAndTime = moment(
      formattedDate + " " + formattedTime,
      "DD-MM-YY hh:mm:ss a"
    );

    return dateAndTime;
  };

  handleTimeSet = () => {
    const { currentAddOns, showDateAndTime } = this.state;
    if (showDateAndTime) {
      currentAddOns["startDate"] = "";
      currentAddOns["endDate"] = "";
      currentAddOns["endTime"] = "";
      currentAddOns["startTime"] = "";
      this.setState({ currentAddOns, showDateAndTime: false });
    } else {
      if (this.props.eventsAbout) {
        currentAddOns["startDate"] = this.timeUTCtoLocal(
          this.props.eventsAbout.StartDateTime
        );
        currentAddOns["endDate"] = this.timeUTCtoLocal(
          this.props.eventsAbout.EndDateTime
        );
        currentAddOns["endTime"] = this.timeUTCtoLocal(
          this.props.eventsAbout.EndDateTime
        );
        currentAddOns["startTime"] = this.timeUTCtoLocal(
          this.props.eventsAbout.StartDateTime
        );
        this.setState({ currentAddOns, showDateAndTime: true });
      }
    }
  };

  inputFields = (state) => {
    const { classes } = this.props;
    const {
      addOnName,
      addOnDescription,
      addOnQuantity,
      addOnPrice,
      color,
      sold,
      ticketsTypes,
      startDate,
      endDate,
      startTime,
      endTime,
    } = state;

    const labels = Tickets.addons.addAddons;

    return (
      <Grid className={classes.createEventFAQGridWrapper}>
        {/* name */}
        <FormControl>
          <span className={classes.createEventFAQInputLabel}>
            {labels.name}
            <span style={{ color: "red" }}> *</span>
          </span>
          <TextField
            required
            className={`${classes.createEventFAQLongInputField} ${classes.createEventFAQSubmittedFAQ}`}
            placeholder={"Enter name of the add-on"}
            margin="normal"
            value={addOnName}
            onChange={(e) => this.validateAddOnName(e, "addOnName")}
            fullWidth
            InputProps={{
              disableUnderline: true,
              className: classes.createEventFAQInputText,
            }}
            onInput={(e) => {
              e.target.value =
                e.target.value.length > 50
                  ? e.target.value.slice(0, 50)
                  : e.target.value;
            }}
            helperText={
              this.state.errorMessage === ""
                ? `${addOnName.length}/50`
                : this.state.errorMessage
            } // error message
            error={this.state.error}
            FormHelperTextProps={{
              className:
                this.state.errorMessage === ""
                  ? classes.addOnNameInputHelperText
                  : classes.addOnNameInputHelperTextwithErr,
            }}
          />{" "}
        </FormControl>
        {/* description */}
        <FormControl>
          <span className={classes.createEventFAQInputLabel}>
            {labels.description} (optional)
          </span>
          <textarea
            maxLength={160}
            value={this.state.currentAddOns.addOnDescription}
            onChange={(e) =>
              this.setState({
                currentAddOns: {
                  ...this.state.currentAddOns,
                  addOnDescription: e.target.value,
                },
              })
            }
            style={{
              height: 200,
              width: "100%",
              resize: "none",
              padding: 10,
              whiteSpace: "pre-line",
              margin: "10px 0px 20px 0px",
              border: "1px solid #ced4da",
              outline: "none",
              overflowWrap: "break-word",
            }}
          />
          <span
            style={{
              color: "rgba(0, 0, 0, 0.54)",
              position: "absolute",
              bottom: 30,
              left: 14,
              fontSize: 12,
            }}
          >{`${this.state.currentAddOns.addOnDescription.length}/160`}</span>
        </FormControl>
        {/* quantity */}
        <FormControl>
          <span className={classes.createEventFAQInputLabel}>
            {labels.quantity}
            <span style={{ color: "red" }}> *</span>
          </span>

          <TextField
            required
            className={`${classes.createEventFAQLongInputField}`}
            placeholder={"50"}
            margin="normal"
            fullWidth
            type="number"
            value={addOnQuantity}
            onChange={(e) => this.validateInput(e, "addOnQuantity", sold)}
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
            InputProps={{
              disableUnderline: true,
              className: classes.createEventFAQInputText,
            }}
            onInput={(e) => {
              let isSpecial = !/[*\":<>[\]{}`\\()'=;@%#!^$.]/.test(
                e.target.value
              );
              e.target.value = isSpecial ? e.target.value : addOnQuantity;
            }}
            helperText={this.state.addOnQuantityErrorMessage} // error message
            error={this.state.addOnQuantityError}
          />
        </FormControl>

        {/* price */}
        <div>
          <span className={classes.createEventFAQInputLabel}>
            {labels.price}
            <span style={{ color: "red" }}> *</span>
          </span>
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <TextField
              id="standard-adornment-amount"
              type="number"
              InputProps={{
                disableUnderline: true,
                style: { fontSize: "16px" },
              }}
              placeholder={localStorage.getItem("CurrencySymbol") + " 0.00"}
              onWheel={(e) => e.target.blur()}
              value={addOnPrice}
              onKeyDown={(e) =>
                ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
              }
              onChange={(e) => this.validateInput(e, "addOnPrice")}
              disableUnderline={true}
              style={{
                border: "1px solid #ced4da",
                margin: "15px 0px 20px 0px",
                padding: "10px",
                width: "100%",
              }}
            />
          </div>
        </div>
        {/* max number */}

        {/* color */}
        <FormControl>
          <span
            className={classes.createEventFAQInputLabel}
            style={{ width: "50%" }}
          >
            {labels.color} (optional)
          </span>
          <TextField
            className={`${classes.createEventFAQLongInputField}`}
            id="standard-adornment-amount"
            type="color"
            InputProps={{
              disableUnderline: true,
              style: { fontSize: "16px" },
            }}
            inputProps={{
              style: {
                height: "2.5rem",
                padding: "0px",
              },
            }}
            style={{ width: "50%", marginBottom: "10px" }}
            onWheel={(e) => e.target.blur()}
            value={color}
            onChange={(e) =>
              this.setState({
                currentAddOns: {
                  ...this.state.currentAddOns,
                  color: e.target.value,
                },
              })
            }
          />
        </FormControl>

        {/* date and time */}
        <Box
          sx={{
            marginTop: "20px",
          }}
        >
          <FormControlLabel
            value="Set a time/date for this add on"
            control={
              <Checkbox
                style={{
                  transform: "scale(1.7)",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
                checked={this.state.showDateAndTime}
                color="primary"
                onClick={this.handleTimeSet}
              />
            }
            label={
              <span style={{ fontSize: "16px", fontWeight: 500 }}>
                Set a time/date for this add on
              </span>
            }
            labelPlacement="end"
            style={{
              marginBottom: "20px",
            }}
          />

          {this.state.showDateAndTime ? (
            <FormControl>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span
                  className={classes.createEventFAQInputLabel}
                  style={{ marginBottom: "20px" }}
                >
                  {labels.validFrom} (optional: adjust time to save)
                </span>
              </div>
              <DateAndTime
                varStartDate={moment(startDate)}
                varEndDate={moment(endDate)}
                varEndTime={moment(endTime)}
                varStartTime={moment(startTime)}
                maxEndDate={this.timeUTCtoLocal(
                  this.props.eventsAbout && this.props.eventsAbout.EndDateTime
                )}
                minDate={this.timeUTCtoLocal(
                  this.props.eventsAbout && this.props.eventsAbout.StartDateTime
                )}
                funcChangeStartDate={this.ChangeStartDate}
                funcChangeEndDate={this.ChangeEndDate}
                funcChangeStartTime={this.ChangeStartTime}
                funcChangeEndTime={this.ChangeEndTime}
                notMandatory={true}
              />
            </FormControl>
          ) : null}
        </Box>

        <FormControl>
          <span className={classes.createEventFAQInputLabel}>
            {labels.appliesTo}
            <span style={{ color: "red" }}> *</span>
          </span>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "20px",
              "& > label": {
                "& span:nth-child(2)": {
                  fontSize: "16px",
                  marginTop: "9px",
                },
              },
              "& > label:nth-child(1)": {
                borderBottom: "1px solid #ced4da",
                paddingBottom: "8px",
              },
            }}
          >
            <FormControlLabel
              value="All Tickets"
              control={
                <Checkbox
                  style={{
                    transform: "scale(1.7)",
                    marginLeft: "10px",
                    marginTop: "10px",
                    marginRight: "10px",
                  }}
                  checked={ticketsTypes.every((ticket) => ticket.checked)}
                  color="primary"
                  onClick={(e) => this.handleCheckboxAllChange(e)}
                />
              }
              label="All tickets"
              labelPlacement="end"
            />
            {ticketsTypes.map((ticket, index) => {
              return (
                <FormControlLabel
                  key={index}
                  value={ticket.title}
                  control={
                    <Checkbox
                      style={{
                        transform: "scale(1.7)",
                        marginLeft: "10px",
                        marginTop: "10px",
                        marginRight: "10px",
                      }}
                      checked={ticket.checked}
                      color="primary"
                      onClick={(e) => this.handleCheckboxChange(e, index)}
                    />
                  }
                  label={ticket.title.toUpperCase()}
                  labelPlacement="end"
                />
              );
            })}
          </Box>
        </FormControl>
      </Grid>
    );
  };

  progressLoader = () => {
    const { loading } = this.state;

    return loading && <Loader />;
  };

  paymentErrorMessage = () => {
    const { classes, payouts } = this.props;
    const { allAddOns } = this.state;
    const isPaid = allAddOns.some((addon) => addon.addOnPrice > 0);
    const PaymentLabel = Tickets.addons.paymentError;

    if (typeof payouts === "undefined" && isPaid) {
      return (
        <div style={{ textAlign: "center" }}>
          <img
            style={{ width: "30px", marginBottom: "30px" }}
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJMApQvNCc3uQ6jZppL-KCxtAKPvFmqXiIuR7QLSgPZ1j3JTUY9Ffu-Nlz0K2CQEy8cFg&usqp=CAU"
            alt="Error Message"
          />
          <p style={{ color: "red", fontSize: "16px" }}>
            {PaymentLabel.slice(0, PaymentLabel.indexOf("next"))}
            <br />{" "}
            {PaymentLabel.slice(
              PaymentLabel.indexOf("next"),
              PaymentLabel.length - 1
            )}
          </p>
        </div>
      );
    }
  };

  addModal = () => {
    const { classes } = this.props;
    const { addModal, editAddonModal, currentAddOns } = this.state;

    var mandatoryFields = [
      currentAddOns.addOnName.length > 0,
      currentAddOns.addOnQuantity > 0,
      currentAddOns.addOnPrice !== "",
      currentAddOns.all ||
      currentAddOns.ticketsTypes.some((ticket) => ticket.checked),
      !this.state.addOnMaxNumberError,
      !this.state.addOnQuantityError,
    ];

    const labels = Tickets.addons.addAddons;
    return (
      <Modal
        open={addModal || editAddonModal.show}
        onClose={() =>
          editAddonModal.show ? this.setEditState(false) : this.handleAddModal()
        }
      >
        <Box className={classes.addUpdateModal}>
          <div className={classes.addUpdateModalMainWrapper}>
            <div>
              <div className={classes.addUpdateModalHeader}>
                <IconButton
                  onClick={() =>
                    editAddonModal.show
                      ? this.setEditState(false)
                      : this.handleAddModal()
                  }
                >
                  <Close height={30} width={30} />
                </IconButton>
                <p className={classes.addUpdateModalHeaderText}>
                  {editAddonModal.show ? "Edit Add-On" : "Add Add-On"}
                </p>
              </div>
              <div> {this.inputFields(currentAddOns)}</div>
            </div>
            <div
              className={classes.addUpdateModalButtonWrapper}
              id="eventCommonModal"
            >
              <Button
                className={classes.addUpdateModalButtonCancel}
                onClick={() =>
                  editAddonModal.show
                    ? this.setEditState(false)
                    : this.handleAddModal()
                }
              >
                {Text.Cancel}
              </Button>
              <Button
                className={classes.addUpdateModalButtonSave}
                variant={"contained"}
                onClick={() =>
                  editAddonModal.show ? this.saveEditedAddon() : this.addAddon()
                }
                disabled={mandatoryFields.some((field) => field === false)}
                style={{
                  backgroundColor: mandatoryFields.some(
                    (field) => field === false
                  )
                    ? "rgba(163, 56, 164,.4)"
                    : "rgb(163, 56, 164)",
                }}
              >
                {Text.Save}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    );
  };

  checkIfDecimalAndFix = (price) => {
    const numberPrice = Number(price);
    if (numberPrice % 1 != 0) {
      return Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numberPrice);
    } else {
      return numberPrice;
    }
  };

  emptyPageState = () => {
    const { classes } = this.props;
    const labels = Tickets.addons.emptyAddons;

    return (
      <div className={classes.emptyState}>
        <img
          src={labels.img}
          alt="empty"
          style={{ objectFit: "contain", width: "100px" }}
        />
        <h2 className={classes.emptyHeader}>{labels.headline}</h2>
        <p className={classes.emptyHeader}>{labels.description}</p>
      </div>
    );
  };
  handleDeleteError = (show, title = "", body = "") => {
    this.setState({
      deleteError: { show, messageTitle: title, messageBody: body },
    });
  };

  setDeleteModalState = (show, index = -1) => {
    this.setState({
      deleteAddOnsModal: { show: show, index: index },
    });
  };

  setEditAddOnState = (index = "", show) => {
    if (show) {
      const storedAddOn = this.state.allAddOns[index];
      const storedTicketIds = storedAddOn.ticketsTypes || [];
      const isAll = storedAddOn.all;
      const updatedTicketTypes = cloneDeep(currentDefault.ticketsTypes).map(
        (ticket) => ({
          ...ticket,
          checked: isAll
            ? true
            : storedTicketIds.some(
              (mapTicket) => mapTicket.TicketId === ticket.ticketId
            ),
        })
      );

      const updatedCurrentAddOn = {
        ...storedAddOn,
        ticketsTypes: updatedTicketTypes,
      };

      this.setState({
        editAddonModal: { show: true, index: index },
        currentAddOns: updatedCurrentAddOn,
        showDateAndTime: storedAddOn?.startDate && storedAddOn?.endDate,
      });
    } else {
      this.setState({
        editAddonModal: { show: false, index: "" },
        currentAddOns: cloneDeep(currentDefault),
        showDateAndTime: false,
      });
    }
  };
  isPlainObject = (variable) => {
    return (
      typeof variable === "object" &&
      variable !== null &&
      !Array.isArray(variable)
    );
  };

  parseAndValidateJSON = (jsonString) => {
    // Replace 'null' with 'null' and single quotes with double quotes
    const replacedString = jsonString
      .replace(/'/g, '"')
      .replace(/null/g, "null");

    try {
      const parsedData = JSON.parse(replacedString);
      return { success: true, data: parsedData };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  formatCurrency(value, currencySymbol) {
    // Format the number as currency
    return (
      currencySymbol +
      Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value))
    );
  }

  filterUnwantedKeys = (obj) => {
    const filteredObject = {};

    for (const key in obj) {
      if (isNaN(key)) {
        filteredObject[key] = obj[key];
      }
    }

    return filteredObject;
  };

  jsonFormatterHelper = (ListAttendee) => {
    const filterdObjects = ListAttendee.map((item) => {
      const jsonobj = item.AdditionalDetails;
      const {
        Data,
        Message,
        ResponseCode,
        AdditionalDetails,
        Email,
        ...restItem
      } = item;

      if (jsonobj) {
        let parsedData = {};
        try {
          const parsedJsonObj = this.parseAndValidateJSON(jsonobj);
          let restInfo = {};
          if (parsedJsonObj.success && parsedJsonObj.data?.FullName) {
            restInfo = { ...parsedJsonObj.data };
          } else {
            const modifiedJson = JSON.parse(jsonobj, (key, value) => {
              if (typeof value === "string") {
                // Replace single quotes within string values with apostrophes
                return value.replace(/'/g, "\\'");
              }
              return value;
            });

            parsedData = JSON.parse(jsonobj);
            const data = JSON.parse(parsedData);

            restInfo = { ...modifiedJson, ...data };
          }

          return { ...restInfo, ...restItem };
        } catch (e) {
          const isObject = this.isPlainObject(parsedData);

          if (isObject) {
            return { ...parsedData, ...restItem };
          }

          // Replace single quotes with double quotes
          const correctedJsonString = parsedData.replace(/'/g, '"');
          const newParsedData = JSON.parse(correctedJsonString);
          return { ...newParsedData, ...restItem };
        }
      } else {
        return { FullName: "", Email: "", Phone: "", ...restItem };
      }
    });
    const filteredDetails = filterdObjects?.map((obj) =>
      this.filterUnwantedKeys(obj)
    );
    return filteredDetails;
  };

  downloadAllAttendeeByAddOnId = async (addonId, Title) => {
    try {
      // Fetch Attendees list
      const { TimeZone } = this.props.eventsAbout;
      const { data } = await axiosE.get(
        `DownloadAllAttendeeByAddOnId/${addonId}`
      );
      const timeUTCtoLocal = (date) => {
        var local = moment
          .tz(moment.utc(date), "MM/DD/YYYY hh:mm:ss a", TimeZone)
          .format("MM/DD/YYYY hh:mm:ss a");
        return moment(local, "MM/DD/YYYY hh:mm:ss a").format("llll");
      };

      if (data?.results?.ListAttendee?.length > 0) {
        const filterdObjects = this.jsonFormatterHelper(
          data.results.ListAttendee
        );

        // Create a new workbook
        const workbook = new ExcelJS.Workbook();

        // Add a worksheet to the workbook
        const worksheet = workbook.addWorksheet("Attendee List");

        // Set column headers and make them bold
        const predefinedColumns = [
          { header: "Order ID", key: "OrderId", width: 15 },
          { header: "Event ID", key: "EventId", width: 15 },
          { header: "Full Name", key: "FullName", width: 20 },
          { header: "Email", key: "Email", width: 25 },
          { header: "Phone", key: "Phone", width: 15 },
          { header: "Order Date", key: "OrderDate", width: 20 },
          { header: "Confirmed Add-On Date/Time", key: "ScannedDateTime", width: 20 },
          { header: "Status", key: "Status", width: 15 },
          { header: "Ticket Name", key: "TicketType", width: 30 },
          { header: "Ticket Quantity", key: "TicketQuantity", width: 15 },
          { header: "Add-On Name", key: "AddOnName", width: 30 },
          { header: "Add-On Quantity", key: "AddOnQuantity", width: 15 },
          { header: "Add-On Price", key: "AddOnPrice", width: 15 },
        ];

        // Convert UTC OrderDate to local time in sortedObjects
        const sortedObjects = filterdObjects.map((obj) => {
          const localOrderDate = timeUTCtoLocal(obj.OrderDate); // Assuming the OrderDate field contains UTC timestamps
          return { ...obj, OrderDate: localOrderDate };
        });

        // Sort the sortedObjects array in descending order based on OrderDate
        sortedObjects.sort(
          (a, b) => new Date(b.OrderDate) - new Date(a.OrderDate)
        );

        // Define a list of columns to exclude
        const columnsToExclude = [
          "Amount",
          "BookingDate",
          "BookingTime",
          "CurrencyCode",
          "CurrencySymbol",
          "DiscountAmount",
          "DiscountCode",
          "Email",
          "EventId",
          "FullName",
          "OrderDate",
          "OrderId",
          "PdfFile",
          "Phone",
          "QRCode",
          "Price",
          "RecurringInterval",
          "RecurringTicket",
          "ScannedDateTime",
          "Re_ScannedDateTime",
          "Status",
          "TaxAmount",
          "TaxName",
          "Title",
          "TotalCounts",
          "UBMeFeeAmount",
          "isAbsorb",
          "Terms_And_Conditions",
          "TermsAndConditions",
          "isBundle",
          "SlotPerBundle",
          "TicketDescription",
          "Notes",
          "UserId",
          "IsAnonymousAllowed",
          "AddOns",
          "AddonGroupId",
          "IsCardProcessingFeeAbsorb",
          "CardProcessingFeeAmount",
          "PaymentMethod",
          "OrderStatus"
        ];

        // Define additional columns by filtering out excluded columns
        const additionalColumns = Object.keys(sortedObjects[0])
          .filter((columnName) => {
            return (
              !columnsToExclude.includes(columnName) &&
              columnName !== "ExoticFields"
            );
          })
          .map((columnName) => ({
            header: columnName.replace(/_/g, " "), // Display name for the column
            key: columnName, // Unique identifier for the column
            width: 15, // Optional: specify the column width
          }));

        // Check if ExoticFields exists and is an object
        var exoticColumns = [];
        if (
          sortedObjects[0].ExoticFields &&
          typeof sortedObjects[0].ExoticFields === "object"
        ) {
          // Loop through the keys (questions) in ExoticFields
          Object.keys(sortedObjects[0].ExoticFields).forEach(
            (fieldKey, index) => {
              const field = sortedObjects[0].ExoticFields[fieldKey]; // Get field details
              exoticColumns.push({
                header: fieldKey.replace(/_/g, " "), // Use field key as header or label
                key: fieldKey, // Field key as column key
                width: 20,
              });
            }
          );
        }

        // Combine predefined and additional columns for the header row
        const allHeaders = predefinedColumns

        // Extract keys from allHeaders
        const allHeadersKeys = allHeaders.map((header) => header.header);

        // Add the header row for detailed headers (5th row) with headers and widths
        const headerRow = worksheet.addRow(allHeadersKeys.map((key) => key)); // Include allHeadersKeys here if needed
        headerRow.font = { bold: true };

        let currencySymbol = "";

        // Group rows by orderId and collect ticket details for each orderId
        const groupedRows = sortedObjects.reduce((acc, row) => {
          var key = "";
          if (row.IsAnonymousAllowed === "True") {
            key = `${row.OrderId}-${row.FullName}-${row.Email}-${row.Phone}-${row.OrderDate}`;
          } else {
            key = `${row.OrderId}-${row.QRCode}`; // Use unique QR Code to prevent grouping
          }

          if (!acc[key]) {
            acc[key] = {
              ...row,
              TicketType: [],
              TicketId: [],
              TicketStatuses: [],
              AddOnName: [],
              AddOnPrice: [],
              AddOnDetails: []
            };
          }

          const ticketType =
            row.Status === "Refunded" ? `${row.Title} (Refunded)` : row.Title;

          acc[key].TicketType.push(ticketType);
          acc[key].TicketId.push(row.QRCode);
          acc[key].TicketStatuses.push(row.Status);

          const ticketDetail = {
            TicketName: row.Title,
            TicketId: row.QRCode,
            ConfirmedDateTime:
              row.ScannedDateTime !== ""
                ? timeUTCtoLocal(row.ScannedDateTime)
                : "",
            ReScannedDateTime: [], // Store multiple ReScannedDateTime values
          };

          // Parse the ReScannedDateTime JSON string into an array of objects
          let reScannedDateTimeArray = [];
          try {
            reScannedDateTimeArray = JSON.parse(row.Re_ScannedDateTime);
          } catch (error) {
            console.error("Error parsing Re_ScannedDateTime:", error);
          }

          // Check if ReScannedDateTime is available and push it to the array
          reScannedDateTimeArray.forEach((entry) => {
            ticketDetail.ReScannedDateTime.push(
              timeUTCtoLocal(entry.ScannedDateTime)
            );
          });

          const matchingAddOns = row.AddOns.filter((addOn) => addOn.AddOnId === addonId);
          const addOnsNames = matchingAddOns.map((addOn) => addOn.Name).join(", ");
          acc[key].AddOnName.push(addOnsNames);

          currencySymbol = row.CurrencySymbol;

          const addOnsPrices = matchingAddOns.map((addOn) => addOn.Price).join(", ");
          acc[key].AddOnPrice.push(
              ((addOnsPrices !== "" && addOnsPrices !== "0" && addOnsPrices !== "0.00") && (row.OrderStatus !== "ByOrganizer"))
              ? this.formatCurrency(Number(addOnsPrices), currencySymbol)
              : "Free");

          // ✅ Correctly loop through each add-on to store scanned date-times
          matchingAddOns.forEach((addOn) => {
            const addOnDetail = {
              AddOnName: addOn.Name,
              AddOnId: addOn.AddOnId,
              ReScannedDateTime: [],
            };

            let reScannedAddOnDateTimeArray = [];
            try {
              reScannedAddOnDateTimeArray = JSON.parse(addOn.ScannedDateTime || "[]");
            } catch (error) {
              console.error("Error parsing ScannedDateTime:", error);
            }

            reScannedAddOnDateTimeArray.forEach((entry) => {
              if (entry?.ScannedDateTime) {
                addOnDetail.ReScannedDateTime.push(
                    timeUTCtoLocal(entry.ScannedDateTime)
                );
              }
            });

            acc[key].AddOnDetails.push(addOnDetail);
          });

          return acc;
        }, {});

        // Add data rows and apply alternate row background color
        let prevOrderId = null;
        let rowIndex = 6;
        Object.values(groupedRows).forEach((rowData, index) => {
          const {
            OrderId,
            FullName,
            Email,
            Phone,
            EventId,
            OrderDate,
            TicketType,
            TicketStatuses,
            DiscountAmount,
            DiscountCode,
            TaxFee,
            UBMeFee,
            Amount,
            PdfFile,
            isBundle,
            SlotPerBundle,
            ExoticFields,
            AddonsName,
            AddonsQuantity,
            AddOnName,
            AddOnPrice,
            AddOnDetails
          } = rowData;


          // Initialize an object to store TicketId and corresponding Rescanned Date/Time
          const addonRescannedData = {};

          // Loop through AddOnDetails to group "AddOnId" and "Rescanned Date/Time" values
          AddOnDetails.forEach((addonDetail) => {
            const addOnId = addonDetail.AddOnId;
            const addonName = addonDetail.AddOnName;
            const reScannedDateTimeValues =
                addonDetail.ReScannedDateTime.join("\n"); // Join with line breaks

            if (!addonRescannedData[addOnId]) {
              addonRescannedData[addOnId] = {
                TicketName: addonName,
                RescannedDateTimes: [],
              };
            }

            addonRescannedData[addOnId].RescannedDateTimes =
                addonRescannedData[addOnId].RescannedDateTimes.concat(
                    reScannedDateTimeValues
                );
          });

          let rescannedDateTimeValues = "";
          let addonScanTimes = "";
          addonScanTimes = Object.keys(addonRescannedData)
              .map((id) => {
                const rescannedData = addonRescannedData[id];
                if (
                    rescannedData.RescannedDateTimes[0] !== undefined &&
                    rescannedData.RescannedDateTimes[0] !== ""
                ) {
                  return `Add-On ${
                      rescannedData.TicketName
                  }:\n${rescannedData.RescannedDateTimes.join("\n")}`;
                }
              })
              .filter(Boolean)
              .join("\n\n");

          // Append addonScanTimes after ticket scans
          if (addonScanTimes.length > 0) {
            rescannedDateTimeValues += `\n\n${addonScanTimes}`;
          }

          // let rescannedDateTimeValues = "";
          // // Append Add-On scan times after ticket scans
          // const addonScanTimes = rowData.AddOns
          //     ?.filter((addon) => addon.AddOnId === addonId)
          //     .flatMap((addon) => {
          //       let scans = [];
          //       try {
          //         const parsed = JSON.parse(addon.ScannedDateTime || "[]");
          //         scans = parsed.map((entry) => timeUTCtoLocal(entry.ScannedDateTime));
          //       } catch (e) {
          //         console.error("Failed to parse AddOn ScannedDateTime:", e);
          //       }
          //
          //       if (scans.length > 0) {
          //         return [`Add-On ${addon.Name || "Item"}:\n${scans.join("\n")}`];
          //       }
          //       return [];
          //     })
          //     .filter(Boolean);

          // Append addonScanTimes after ticket scans
          // if (addonScanTimes.length > 0) {
          //   rescannedDateTimeValues = `\n\n${addonScanTimes.join("\n\n")}`;
          // }


          const ticketStatuses = [...new Set(TicketStatuses)]; // Remove duplicate statuses
          let formattedStatus = "";

          if (ticketStatuses.every((status) => status === "Refunded")) {
            formattedStatus = "Refunded"; // All tickets refunded
          } else if (ticketStatuses.every((status) => status === "CheckedIn")) {
            formattedStatus = ""; // All tickets checked in
          } else if (ticketStatuses.includes("Refunded")) {
            formattedStatus = "Partially Refunded"; // Some tickets refunded
          } else if (ticketStatuses.includes("CheckedIn")) {
            formattedStatus = ""; // Some tickets checked in
          } else {
            formattedStatus = ""; // Add more cases if needed
          }

          // Define the array of values for predefined columns
          const predefinedDataArray = [
            OrderId,
            EventId,
            FullName,
            Email,
            Phone,
            OrderDate,
            rescannedDateTimeValues,
            formattedStatus,
            TicketType.join("\n"),
            TicketType.length,
            AddOnName.join("\n") || "",
            AddOnName.length,
            AddOnPrice.join("\n") || "",
          ];

          // Combine predefined and additional data arrays
          const rowDataArray = predefinedDataArray

          // Add the row to the worksheet
          const orderRow = worksheet.addRow(rowDataArray);

          // Apply alternate row background color
          orderRow.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: index % 2 === 0 ? "FFFFFF" : "EFEFEF" },
          };

          if (prevOrderId !== OrderId) {
            prevOrderId = OrderId;
          }

          rowIndex++;
        });

        // ✅ Calculate and add total row after all attendee rows
        let totalAddOnPrice = 0;

        Object.values(groupedRows).forEach((rowData) => {
          const { AddOnPrice } = rowData;
          AddOnPrice.forEach((priceStr) => {
            const numericValue = parseFloat(priceStr.replace(/[^0-9.-]+/g, ""));
            if (!isNaN(numericValue)) {
              totalAddOnPrice += numericValue;
            }
          });
        });

        // ✅ Create a new row only with total in Add-On Price column (index 13)
        const totalRowData = new Array(13).fill(""); // 13 empty cells
        totalRowData[12] = this.formatCurrency(totalAddOnPrice, currencySymbol); // Add to 13th column

        const totalRow = worksheet.addRow(totalRowData);

        // ✅ Style total cell (green bold font)
        const totalCell = totalRow.getCell(13); // Column 13 (1-based)
        totalCell.font = { color: { argb: "FF008000" }, bold: true };
        totalCell.alignment = { horizontal: "center", vertical: "middle" };

        // Set specific column widths based on column index
        worksheet.columns.forEach((column, columnIndex) => {
          if (
            columnIndex === 0 ||
            columnIndex === 1 ||
            columnIndex === 2 ||
            columnIndex === 6 ||
            columnIndex === 7 ||
            columnIndex === 8 ||
            columnIndex === 10
          ) {
            column.width = 40;
          } else if (
            columnIndex === 3 ||
            columnIndex === 4 ||
            columnIndex === 5
          ) {
            column.width = 25;
          } else {
            column.width = 15;
          }
        });

        // Function to apply center alignment to specified columns
        const applyCenterAlignmentToColumns = (worksheet, columnKeys) => {
          columnKeys.forEach((key) => {
            const column = worksheet.getColumn(key);
            column.eachCell((cell) => {
              cell.alignment = {
                horizontal: "center",
                vertical: "middle",
                wrapText: true,
              };
            });
          });
        };

        // Call the function to apply center alignment to "Ticket Quantity" and "Add-Ons Quantity" columns
        applyCenterAlignmentToColumns(worksheet, [10, 12, 13]);

        // Generate XLSX file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, `${Title}.xlsx`);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  getaddonsByEventID = (eventId) => {
    axiosE(`${eventApis.getAddonByEventId}${eventId}`).then((res) => {
      const addons = res.data.results.AddOns;

      if (addons && addons.length > 0) {
        this.setState({
          allAddOns: addons.map((addon, index) => ({
            AddOnId: addon.AddOnId,
            addOnName: addon.Name,
            addOnDescription: addon.Description,
            addOnPrice: Number(addon.Price),
            addOnQuantity: parseInt(addon.QuantityAvailable),
            ticketsTypes: addon.Mappings,
            all: addon.AppliesToAllTickets,
            isDeleted: addon.isDeleted,
            startDate: this.timeUTCtoLocal(addon.StartDateTime),
            endDate: this.timeUTCtoLocal(addon.EndDateTime),
            startTime: this.timeUTCtoLocal(addon.StartDateTime),
            endTime: this.timeUTCtoLocal(addon.EndDateTime),
            color: addon.Color,
            sold: addon.Sold,
            IsDeleted: addon.IsDeleted,
          })),
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    });
  };

  deleteAddons = async (index) => {
    const { allAddOns } = this.state;
    this.setState({ loading: true });
    this.setEventTypeOnDelete(index, allAddOns);
    // Set Event Type
    await this.deleteTicketRemote(allAddOns[index].AddOnId);

    this.setState({
      allAddOns: allAddOns.filter((ticket, i) => i !== index),
      deleteAddOnsModal: { show: false, index: null },
    });
  };

  deleteTicketRemote = async (id) => {
    const { deleteAddonAction, eventId } = this.props;
    deleteAddonAction({ AddOnId: id }).then((res) => {
      this.getaddonsByEventID(eventId);
    });
  };

  deleteErrorMessage = () => {
    const { classes } = this.props;
    const { deleteError } = this.state;
    const { show, messageTitle, messageBody } = deleteError;

    return (
      <Modal open={show} onClose={() => this.handleDeleteError(false)}>
        <Box className={classes.deleteModalMainWrapper}>
          <div className={classes.deleteModalImgWrapper}>
            <img
              src={Events.deleteImg}
              alt="Delete Icon"
              className={classes.deleteModalImg}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <strong>{messageTitle}</strong>
            {messageBody === "add payment method" ? (
              <p>
                {Text.ActiveAtLeastOneTicket}{" "}
                <a
                  href="#"
                  style={{ fontSize: "14px" }}
                  onClick={() => this.props.history.push("Payouts")}
                >
                  {Text.PayoutMethod}
                </a>
              </p>
            ) : (
              <p>{messageBody}</p>
            )}
          </div>
        </Box>
      </Modal>
    );
  };

  deleteModal = () => {
    const { classes } = this.props;
    const { deleteAddOnsModal } = this.state;
    const { show, index } = deleteAddOnsModal;
    const labels = Tickets.addons.deleteaddOns;
    return (
      <Modal open={show} onClose={() => this.setDeleteModalState(false)}>
        <Box className={classes.deleteModalMainWrapper}>
          <div className={classes.deleteModalImgWrapper}>
            <img
              src={labels.img}
              alt="Delete Icon"
              className={classes.deleteModalImg}
            />
          </div>
          <p style={{ textAlign: "center" }}>
            {labels.message}{" "}
            {this.state.allAddOns[index] ? this.state.allAddOns[index].addOnName : ""}?
          </p>
          <p
              style={{
                fontSize: "13px",
                textAlign: "center",
                lineHeight: "15px",
                padding: "10px",
                color: "gray",
              }}
          >
            {labels.info}
          </p>
          <div>
            <Button
              className={classes.deleteModalSaveAndCancelButton}
              onClick={() => this.setDeleteModalState(false)}
              style={{ color: "blue" }}
            >
              {Text.Cancel}
            </Button>

            <Button
              className={classes.deleteModalSaveAndCancelButton}
              onClick={() => this.deleteAddons(index)}
              style={{ color: "red" }}
            >
              {Text.Delete}
            </Button>
          </div>
        </Box>
      </Modal>
    );
  };

  showAddons = () => {
    const { classes, eventType } = this.props;
    const { allAddOns } = this.state;
    return (
      <div className={classes.mainContentWrapper}>
        {this.paymentErrorMessage()}
        {allAddOns.map((addon, i) => (
          <div className={classes.addOnWrapper} key={i}>
            {addon.color && (
              <div
                style={{
                  borderRadius: "10px",
                  border: `5px solid ${addon.color}`,
                  height: "100%",
                }}
              ></div>
            )}
            <div
              className={classes.addOnWrappersub}
              style={{ padding: addon.color ? "22px 22px 22px 10px" : "22px" }}
            >
              <div className={classes.addOnCardColumnOne}>
                <span
                  style={{
                    fontSize: "32px",
                    wordBreak: "break-all",
                    hyphens: "auto",
                  }}
                >
                  {addon.addOnName}
                </span>
                {addon.IsDeleted}
                {addon.addonId === "" || addon.IsDeleted ? (
                  <span
                    className={classes.addOnCardSpecialFlag}
                    style={{
                      backgroundColor: "rgb(255, 48, 48)",
                    }}
                  >
                    Deleted
                  </span>
                ) : null}

                {this.combineDateAndTime(addon.endDate, addon.endTime).isBefore(
                  moment()
                ) ? null : addon?.isDeleted ? (
                  <span style={{ opacity: 0.4 }}>
                    {this.combineDateAndTime(
                      addon.startDate,
                      addon.startTime
                    ).isBefore(moment()) &&
                      this.combineDateAndTime(
                        addon.endDate,
                        addon.endTime
                      ).isAfter(moment())
                      ? "From"
                      : "Available from "}{" "}
                    {moment(addon.startDate).format("MM/DD/YYYY")} to{" "}
                    {moment(addon.endDate).format("MM/DD/YYYY")}
                  </span>
                ) : null}
              </div>
              <div className={classes.addOnCardColumnTwo}>
                <div
                  className={classes.addOnCardButtonWrapper}
                  style={{ display: "initial" }}
                >
                  {!addon.IsDeleted ? (
                    <IconButton onClick={() => this.setEditAddOnState(i, true)}>
                      <Create />
                    </IconButton>
                  ) : null}
                  {!addon?.IsDeleted ? (
                    <IconButton
                      onClick={() => this.setDeleteModalState(true, i)}
                    >
                      <Delete />
                    </IconButton>
                  ) : null}

                  {addon.sold ? (
                    <IconButton
                      onClick={() =>
                        this.downloadAllAttendeeByAddOnId(
                          addon.AddOnId,
                          addon.addOnName
                        )
                      }
                    >
                      <Download />
                    </IconButton>
                  ) : null}
                </div>
                <div style={{ textAlign: "end" }}>
                  <span style={{ fontSize: "35px", display: "block" }}>
                    {addon.addOnPrice
                      ? `${localStorage.getItem(
                        "CurrencySymbol"
                      )}${Intl.NumberFormat(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(
                        Number(this.checkIfDecimalAndFix(addon.addOnPrice))
                      )}`
                      : "Free"}
                  </span>
                  <span style={{ opacity: 0.4, textAlign: "end" }}>
                    {addon?.sold === "" || addon?.sold === undefined
                      ? "0"
                      : addon?.sold}
                    /
                    {addon?.eventRecurring === "True"
                      ? addon?.TotalTicketIssue > 0
                        ? addon?.TotalTicketIssue
                        : addon?.recurringQuantity * addon?.availableSlots
                      : addon?.addOnQuantity}{" "}
                    Add-Ons Sold
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  saveAndContinue = () => {
    const { classes } = this.props;

    return (
      <div className={classes.saveAndContinueButtonWrapper}>
        <Button
          className={classes.saveAndContinueButton}
          variant={"contained"}
          onClick={() => this.props.history.push("Payouts")}
        >
          {Text.SaveAndContinue}
        </Button>
      </div>
    );
  };
  handleError = () => {
    this.setState({ error: { show: false, message: "" } });
  };
  errorMessage = () => (
    <CreateEventErrorMessage
      state={this.state.error}
      close={this.handleError}
    />
  );

  render() {
    const { classes } = this.props;
    const { disableButton } = this.state;
    return (
      <TicketLayout>
        <EventHeader title={"Add-Ons"}>
          {!disableButton && (
            <Button className={classes.addButton} onClick={this.handleAddModal}>
              <span className={classes.createButtonAddText}>Add Add-on </span>
              <AddIcon className={classes.createButtonPlusIcon} />
            </Button>
          )}
        </EventHeader>
        <ContentLayout>
          {this.state.allAddOns.length > 0
            ? this.showAddons()
            : this.emptyPageState()}
          {this.saveAndContinue()}
          {this.addModal()}
          {this.progressLoader()}
          {this.deleteModal()}
          {this.errorMessage()}
          {this.deleteErrorMessage()}
        </ContentLayout>
      </TicketLayout>
    );
  }
}

const mapStateToProps = (state) => {
  const { eventUserEvents } = state;
  return {
    eventId: eventUserEvents.eventId,
    tickets: eventUserEvents.tickets,
    eventsAbout: eventUserEvents.eventsAbout,
    eventType: eventUserEvents.eventType,
    eventPublish: eventUserEvents.eventPublish,
    payouts: eventUserEvents.payouts,
    eventUserEvents: eventUserEvents,
    addons: eventUserEvents.addons,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { addAddonAction, deleteAddonAction, updateAddonAction, setEventType },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(withStyles(styles)(AddOns));
